'use strict';

const rotators = document.querySelectorAll('[data-js-bind="usp-rotator"]');
const INTERVAL_MS = 4500;
const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

rotators.forEach((rotator) => {
  const items = [...rotator.querySelectorAll('.c-header__usps-item')];

  if (items.length < 2 || reduceMotion) {
    return;
  }

  let index = Math.max(0, items.findIndex((item) => item.classList.contains('is-active')));
  let timer = null;

  const show = (nextIndex) => {
    items[index].classList.remove('is-active');
    index = nextIndex;
    items[index].classList.add('is-active');
  };

  const play = () => {
    window.clearInterval(timer);
    timer = window.setInterval(() => {
      show((index + 1) % items.length);
    }, INTERVAL_MS);
  };

  rotator.addEventListener('mouseenter', () => {
    window.clearInterval(timer);
    timer = null;
  });

  rotator.addEventListener('mouseleave', play);

  play();
});
